import {
  resolveReferencePositions,
  splitNoteBodySegments,
} from "@/projectOverview/notes/noteReferences";
import type { HomeMention } from "@/lib/home";
import { toCompactPreview } from "@/lib/home";

export function MentionBody({
  mention,
  compact,
  onRefClick,
}: {
  mention: HomeMention;
  compact?: boolean;
  onRefClick: (type: string, id: string, label: string) => void;
}) {
  if (compact) {
    return (
      <span className="text-label-secondary">
        {toCompactPreview(mention.note_text || mention.note_preview || "", 180)}
      </span>
    );
  }

  const text = String(mention.note_text || mention.note_preview || "");
  const mirrored = text.match(
    /^Hinweis:\s*Diese Notiz wurde aus Auftrag\s+(#[^\s]+)\s+übernommen\.\s*\r?\n\r?\n([\s\S]*)$/,
  );

  if (mirrored) {
    const hint = `Hinweis: Diese Notiz wurde aus Auftrag ${mirrored[1]} übernommen.`;
    const message = mirrored[2] || "";
    return (
      <>
        <div className="eh-home-mention-system">{renderSegments(hint, mention, onRefClick)}</div>
        {message ? (
          <div className="mt-1">{renderSegments(message, mention, onRefClick)}</div>
        ) : null}
      </>
    );
  }

  return <>{renderSegments(text, mention, onRefClick)}</>;
}

function renderSegments(
  text: string,
  mention: HomeMention,
  onRefClick: (type: string, id: string, label: string) => void,
) {
  const refs = resolveReferencePositions(text, mention.note_references || []);
  const segments = splitNoteBodySegments(text, refs);
  return (
    <>
      {segments.map((seg, idx) => {
        if (seg.kind === "ref" && seg.ref) {
          return (
            <button
              key={`ref-${idx}-${seg.ref.start}`}
              type="button"
              className="eh-home-mention-ref"
              onClick={(e) => {
                e.stopPropagation();
                onRefClick(
                  seg.ref!.type,
                  seg.ref!.ref_id,
                  seg.ref!.label || seg.text,
                );
              }}
            >
              {seg.text}
            </button>
          );
        }
        return (
          <span key={`t-${idx}`} className="whitespace-pre-wrap">
            {seg.text}
          </span>
        );
      })}
    </>
  );
}
